/**
 * CPF que o cadastro passa para o login quando descobre que ele já tem conta.
 *
 * O link "Já tenho conta" do `signup-id` navega pelo `loginLink` do ACUL, que não
 * carrega o identificador; o `login-id` lê o hint no mount e o consome.
 * `sessionStorage`, mesma aba — igual ao rascunho do cadastro.
 */

import { digitsOnly, formatCpf } from './cpf'

const HINT_KEY = 'alelo_login_cpf_hint'

export function save(cpf: string): void {
  try {
    sessionStorage.setItem(HINT_KEY, digitsOnly(cpf))
  } catch {
    // Storage indisponível: o login abre com o campo vazio.
  }
}

/** CPF mascarado, ou `''` sem hint válido. Consome o hint sempre. */
export function consume(): string {
  let raw: string | null = null
  try {
    raw = sessionStorage.getItem(HINT_KEY)
    sessionStorage.removeItem(HINT_KEY)
  } catch {
    return ''
  }
  const cpf = digitsOnly(raw ?? '')
  return cpf.length === 11 ? formatCpf(cpf) : ''
}
